/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uk_Email_Mp_Uk_Only_NoticeInputs */

const en_uk_email_mp_uk_only_notice = /** @type {(inputs: Uk_Email_Mp_Uk_Only_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<b>This tool is for the UK only.</b> For other countries, use the [global email builder](/email-builder).`)
};

/**
* | output |
* | --- |
* | "<b>This tool is for the UK only.</b> For other countries, use the [global email builder](/email-builder)." |
*
* @param {Uk_Email_Mp_Uk_Only_NoticeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const uk_email_mp_uk_only_notice = /** @type {((inputs?: Uk_Email_Mp_Uk_Only_NoticeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uk_Email_Mp_Uk_Only_NoticeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_uk_email_mp_uk_only_notice(inputs)
});